export default function (el) {
  return window.bgl.process[el.name](el)
}
